module.exports = __webpack_public_path__ + "img/mobileapplication5.ac9a31fa.png";